import { render, staticRenderFns } from "./ManageFiles.vue?vue&type=template&id=50f4ca9f&scoped=true&"
import script from "./ManageFiles.vue?vue&type=script&lang=js&"
export * from "./ManageFiles.vue?vue&type=script&lang=js&"
import style0 from "./ManageFiles.vue?vue&type=style&index=0&id=50f4ca9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f4ca9f",
  null
  
)

export default component.exports